module.exports = "/_next/static/media/669fc2cd542528f8edd687faa92bf483.svg";